import { render } from "./SalesModul.vue?vue&type=template&id=fc8c268e"
import script from "./SalesModul.vue?vue&type=script&lang=js"
export * from "./SalesModul.vue?vue&type=script&lang=js"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__